import {VueReCaptcha} from 'vue-recaptcha-v3';
import type {IReCaptchaOptions} from 'vue-recaptcha-v3/dist/IReCaptchaOptions';
import useSpeedMode from '~/composables/useSpeedMode';

export default defineNuxtPlugin((nuxtApp) => {
	const {isSpeedMode} = useSpeedMode();
	if (isSpeedMode.value) { return; }

	const config = useRuntimeConfig();

	const options: IReCaptchaOptions = {
		siteKey: String(config.public.recaptchaSiteKey),
		loaderOptions: {autoHideBadge: true},
	};
	nuxtApp.vueApp.use(VueReCaptcha, options);
});
